import { useTranslation } from 'react-i18next';
import { MapBaseLayerNames } from 'features/mapping/mapping.constants';
import { useKeyboardShortcuts } from 'hooks/useKeyboardShortcuts/useKeyboardShortcuts';
import { BaseMapLayer, useMapLayersState } from '../../state/useMapLayersState';
import { trackMapBaseLayerChangeToPosthog } from '../../features/mapping/mapping.utils';

export const useMapBaseLayerCommandPaletteActions = (): void => {
  const { t } = useTranslation();
  const { mapBaseLayer, setMapBaseLayer } = useMapLayersState();

  const handleSetMapBaseLayer = (baseLayer: BaseMapLayer): void => {
    setMapBaseLayer(baseLayer);
    trackMapBaseLayerChangeToPosthog(baseLayer);
  };

  // Base maps are a radio group, so exactly one entry carries the active dot.
  useKeyboardShortcuts(
    [
      {
        category: 'baseMap',
        description: t('keyboardShortcuts.mapBaseLayer.street'),
        keys: 'b 1',
        isActive: mapBaseLayer === MapBaseLayerNames.STREET,
        handler: () => handleSetMapBaseLayer(MapBaseLayerNames.STREET),
      },
      {
        category: 'baseMap',
        description: t('keyboardShortcuts.mapBaseLayer.satellite'),
        keys: 'b 2',
        isActive: mapBaseLayer === MapBaseLayerNames.SATELLITE,
        handler: () => handleSetMapBaseLayer(MapBaseLayerNames.SATELLITE),
      },
      {
        category: 'baseMap',
        description: t('keyboardShortcuts.mapBaseLayer.topographic'),
        keys: 'b 3',
        isActive: mapBaseLayer === MapBaseLayerNames.TOPOGRAPHIC,
        handler: () => handleSetMapBaseLayer(MapBaseLayerNames.TOPOGRAPHIC),
      },
    ],
    // Re-register when the base map changes so isActive stays fresh
    [mapBaseLayer],
  );
};
